export default __webpack_public_path__ + "static/media/xk.35808a5d.svg";